module.exports = __webpack_public_path__ + "img/c_center-horizontally.9f511db1.svg";